<template>
<div class="container" v-if="info">

<div class="row">
	<img :src="picurl+info.pic" :alt="info.name">
</div>

<div class="row ii">
	<h3>{{info.name}}</h3>
	<p class="gray">({{info.zw}})</p>
</div>

<div class="row ii">
	<h3>简介</h3>
	<p class="gray" v-html="info.content"></p>
</div>

<div class="row ii" style="border:0;">
	<h3>擅长</h3>
	<p class="gray" v-html="info.good"></p>
</div>


</div>
</template>

<style scoped>
.container{padding-bottom: 2rem;}
h3{padding:.5rem 0;}
img{width:90%;margin:5% 5% 0 5%;}
.ii{width:90%;margin:0 5%;padding:.5rem 0;border-bottom: 1px solid #eee;}	
</style>

<script>

export default {
	data:function(){
		return {
			info:"",
			picurl:window.picurl,
		}
	},
	created:function(){
		mydata.back=true;
		this.init();
	},
	beforeDestroy:function(){
        mydata.back=false;
    },
	methods:{
		init:function(){
           var data={
           	id:this.$route.params.id,
           }
           var _this=this;
           if(fun.cache(fun.url())){
           	 this.info=fun.cache(fun.url());return;
           }
           fun.post(window.api+"doctor",data,function(d){
           	console.log(d);
           	if(d.status==1){
           		_this.info=d.info;
           		fun.cache(fun.url(),d.info);
           	}else{
           		_this.$toast(d.info);
           	}
           })
		}
	}
}	
</script>


// WEBPACK FOOTER //
// src/components/thm/doctor.vue